import { Network } from 'lucide-react';

// layer table of a loaded CAD plan: suggested use per layer, user confirms / changes
export function DxfLayers({ L, kind, dxf, setDxf, onBuild, busy }) {
  const set = (i, p) => setDxf({ ...dxf, layers: dxf.layers.map((l, k) => (k === i ? { ...l, ...p } : l)) });
  const sys = kind === 'sewer' ? ['SW', 'RW', 'MW'] : ['W'];
  return (
    <div className="ni-dxf" data-testid="ni-dxf">
      <small className="muted">{dxf.name} · {L.dxfIntro}</small>
      <table className="ni-dxf-tab"><thead><tr><th>{L.dxfLayer}</th><th>{L.dxfObj}</th><th>{L.dxfRole}</th></tr></thead>
        <tbody>{dxf.layers.map((l, i) => (
          <tr key={l.layer} data-testid={`ni-dxf-row-${i}`}>
            <td title={l.layer}>{l.layer}</td>
            <td><small>{[l.lines && `${l.lines} ⁄`, l.points && `${l.points} •`, l.texts && `${l.texts} T`].filter(Boolean).join(' ')}</small></td>
            <td><select data-testid={`ni-dxf-role-${i}`} value={l.role} onChange={(e) => set(i, { role: e.target.value })}>{Object.entries(L.role).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
              {l.role === 'pipe' && sys.length > 1 && <select data-testid={`ni-dxf-sys-${i}`} value={l.sys} onChange={(e) => set(i, { sys: e.target.value })}>{sys.map((k) => <option key={k} value={k}>{L.sysName[k]}</option>)}</select>}</td>
          </tr>))}</tbody>
      </table>
      <button className="btn btn-outline btn-sm" data-testid="ni-dxf-build" disabled={!!busy || !dxf.layers.some((l) => l.role === 'pipe')} title={L.dxfNoPipe} onClick={onBuild}><Network size={14} /> {L.dxfBuild}</button>
    </div>
  );
}
